<template>
  <div class="tier-selector PHD">
    <div class="container container-fluid">
        <h1 class="page-heading">Membership Tier API Data DEMO</h1>
    </div>

    <div class="container container-fluid">
        <h2>Professional Partnership</h2>
        <p class="mb-5">Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur cumque sequi, veritatis animi aspernatur, nobis perferendis, necessitatibus corporis adipisci maxime ut. Deleniti voluptatum non quisquam doloremque nemo consectetur eaque! Pariatur. <br/><a href="#" @click.prevent="" v-b-modal="'table-comparison-modal'" class="text-primary">Click here to Compare Partnership &#187;</a></p>

        <h3>Testing - Trigger Early Career Modal</h3>
        <a href="#" @click.prevent="" v-b-modal="'ec-membership-modal'" class="text-primary">Early Career Modal Trigger</a>

        
        <h3 class="my-4">Content Author can change icons</h3>

       
        
        <!-- COMPONENT - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -->
        <member-tier-selector
        component-title=" Professional Membership"
        :icons="membershipIcons" 
        uri="/PhpApiProxy/GetMemberTierAsync" 
        flow-type="new" 
        :disable-signup="false" 
        promomsg="Have a promo code?" 
        promo-modal-header="Processing Request"
        promo-modal-message="Associating promo code to order."
        class="mb-5"
        >
        </member-tier-selector>
        <!-- END COMPONENT - - - - - - - - - - - - - - - - - - - - - - - - - - - - -->
        <!-- MODAL - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -->
        <aha-modal id="table-comparison-modal" hide-footer centered class="table-comparison__modal">
            <!-- COMPARISON CHART -->
            <div class="row">
                <div class="col">
                    <h2 class="text-center">Pick a Membership that's right for you</h2>
                    <br>
                    <p class="text-center text-muted">
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Pariatur possimus ex incidunt quod eius delectus atque iste, saepe repellat impedit iusto, non repudiandae nemo accusamus alias magnam dolore maxime soluta.
                    </p>
                    <br>
                    <!-- DESKTOP  -->
                    <!-- TABLE -->
                    <div class="l-comparison--desktop">
                        <table class="table table-hover table-comparison">
                            <thead>
                                <tr>
                                <th scope="col" class="text-center">&nbsp;</th>
                                <th scope="col" class="text-center">Premier</th>
                                <th scope="col" class="text-center">Professional</th>
                                <th scope="col" class="text-center">Limited</th>
                                <th scope="col" class="text-center">Signature</th>
                                </tr>
                            </thead>
                            <tbody>
                                
                                <tr>
                                    <td>Journals</td>
                                    <td class="text-center dot dot--active">&#8226;</td>
                                    <td class="text-center dot dot--active">&#8226;</td>
                                    <td class="text-center dot dot--active">&#8226;</td>
                                    <td class="text-center dot dot--active">&#8226;</td>
                                </tr>
                                <tr>
                                    <td>Council Affiliations</td>
                                    <td class="text-center dot dot--active">&#8226;</td>
                                    <td class="text-center dot dot--active">&#8226;</td>
                                    <td class="text-center dot dot--active">&#8226;</td>
                                    <td class="text-center dot dot--active">&#8226;</td>
                                </tr>
                                <tr>
                                    <td>Discount</td>
                                    <td class="text-center dot dot--active">&#8226;</td>
                                    <td class="text-center dot dot--active">&#8226;</td>
                                    <td class="text-center dot dot--active">&#8226;</td>
                                    <td class="text-center dot dot--active">&#8226;</td>
                                </tr>
                                <tr>
                                    <td>FAHA</td>
                                    <td class="text-center dot dot--active">&#8226;</td>
                                    <td class="text-center dot dot--active">&#8226;</td>
                                    <td class="text-center dot dot--active">&#8226;</td>
                                    <td class="text-center dot dot--active">&#8226;</td>
                                </tr>
                                <tr>
                                    <td>Funding opportunities <em>members only</em></td>
                                    <td class="text-center dot dot--active">&#8226;</td>
                                    <td class="text-center dot dot--active">&#8226;</td>
                                    <td class="text-center dot ">&#8226;</td>
                                    <td class="text-center dot ">&#8226;</td>
                                </tr>
                                <tr>
                                    <td>Leadership opportunities</td>
                                    <td class="text-center dot dot--active">&#8226;</td>
                                    <td class="text-center dot dot--active">&#8226;</td>
                                    <td class="text-center dot ">&#8226;</td>
                                    <td class="text-center dot">&#8226;</td>
                                </tr>
                                <tr>
                                    <td>Network with like-minded professionals</td>
                                    <td class="text-center dot dot--active">&#8226;</td>
                                    <td class="text-center dot dot--active">&#8226;</td>
                                    <td class="text-center dot dot">&#8226;</td>
                                    <td class="text-center dot dot">&#8226;</td>
                                </tr>
                                <tr>
                                    <td>Get involved in the AHA mission and mentor others</td>
                                    <td class="text-center dot dot--active">&#8226;</td>
                                    <td class="text-center dot dot--active">&#8226;</td>
                                    <td class="text-center dot ">&#8226;</td>
                                    <td class="text-center dot ">&#8226;</td>
                                </tr>
                                <tr>
                                    <td>Access to Science News</td>
                                    <td class="text-center dot dot--active">&#8226;</td>
                                    <td class="text-center dot ">&#8226;</td>
                                    <td class="text-center dot ">&#8226;</td>
                                    <td class="text-center dot ">&#8226;</td>
                                </tr>
                                <tr>
                                    <td>Eligible for AHA council grants and awards</td>
                                    <td class="text-center dot dot--active">&#8226;</td>
                                    <td class="text-center dot ">&#8226;</td>
                                    <td class="text-center dot ">&#8226;</td>
                                    <td class="text-center dot ">&#8226;</td>
                                </tr>
                                <tr>
                                    <td>Quarterly AHA Connections Newsleter</td>
                                    <td class="text-center dot dot--active">&#8226;</td>
                                    <td class="text-center dot ">&#8226;</td>
                                    <td class="text-center dot ">&#8226;</td>
                                    <td class="text-center dot ">&#8226;</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <!-- END TABLE -->
                    <!-- MOBILE - COLLAPSE -->
                    <div class="l-comparison--mobile">
                        <!-- / -->
                        <div class="l-comparison__wrapper">
                        <b-button v-b-toggle.collapse-tier-premier class="btn--select btn-block text-left">Premier</b-button>
                        <b-collapse id="collapse-tier-premier" class="mt-2">
                            <ul class="list-unstyled">
                                <li>Journals</li>
                                <li>Councils Affiliations</li>
                                <li>Discount</li>
                                <li>FAHA</li>
                                <li>Funding opportunities members only</li>
                                <li>Leadership opportunities</li>
                                <li>Network with like-minded professionals</li>
                                <li>Get involved in the AHA mission and mentor others</li>
                                <li>Access to Science News</li>
                                <li>Eligible for AHA council grants and awards</li>
                                <li>Quarterly AHA Connections Newsleter</li>
                            </ul>
                        </b-collapse>
                        </div>
                        <!-- / -->
                        <!-- / -->
                        <div class="l-comparison__wrapper">
                        <b-button v-b-toggle.collapse-tier-professional class="btn--select btn-block text-left">Professional</b-button>
                        <b-collapse id="collapse-tier-professional" class="mt-2">
                            <ul class="list-unstyled">
                                <li>Journals</li>
                                <li>Councils Affiliations</li>
                                <li>Discount</li>
                                <li>FAHA</li>
                                <li>Funding opportunities members only</li>
                                <li>Leadership opportunities</li>
                                <li>Network with like-minded professionals</li>
                                <li>Get involved in the AHA mission and mentor others</li>
                            </ul>
                        </b-collapse>
                        </div>
                        <!-- / -->
                        <!-- / -->
                        <div class="l-comparison__wrapper">
                        <b-button v-b-toggle.collapse-tier-limited class="btn--select btn-block text-left">Limited</b-button>
                        <b-collapse id="collapse-tier-limited" class="mt-2">
                            <ul class="list-unstyled">
                                <li>Journals</li>
                                <li>Councils Affiliations</li>
                                <li>Discount</li>
                                <li>FAHA</li>
                            </ul>
                        </b-collapse>
                        </div>
                        <!-- / -->
                        <!-- / -->
                        <div class="l-comparison__wrapper">
                        <b-button v-b-toggle.collapse-tier-signature class="btn--select btn-block text-left">Signature</b-button>
                        <b-collapse id="collapse-tier-signature" class="mt-2">
                            <ul class="list-unstyled">
                                <li>Journals</li>
                                <li>Councils Affiliations</li>
                                <li>Discount</li>
                                <li>FAHA</li>
                            </ul>
                        </b-collapse>
                        </div>
                        <!-- / -->
                    </div>

                </div>
            </div>
            <!-- END COMPARISON CHART -->
        </aha-modal>
        <!-- END MODAL - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -->
        
        
    </div>
  
  </div>
</template>

<script>

export default {
    data() {
        return {
            membershipIcons: {
                'membershipicons':
                [
                    { "name": "Premium Professional Plus", "code": "PS", "path":"https://sitecoretestphd.heart.org//-/media/feature/phd/membershipbriefcaseblack.svg?h=24&amp;w=27&amp;hash=A11AADA7C43F77E34BB5F2814189C976490CCF2C" },
                    { "name": "Premium Professional", "code": "PP", "path":"https://sitecoretestphd.heart.org//-/media/feature/phd/membershiphandcardblack.svg?h=30&amp;w=31&amp;hash=BAB1D2A11B434241306F4CFD8B390890DA8BE6F7" },
                    { "name": "General Professional", "code": "GM", "path":"https://sitecoretestphd.heart.org//-/media/feature/phd/membershipbriefcaseblack.svg?h=24&amp;w=27&amp;hash=A11AADA7C43F77E34BB5F2814189C976490CCF2C" },
                    { "name": "Early Career", "code": "EC", "path":"https://sitecoretestphd.heart.org//-/media/feature/phd/membershipbriefcaseblack.svg?h=24&amp;w=27&amp;hash=A11AADA7C43F77E34BB5F2814189C976490CCF2C" },
                    { "name": "Student/Trainee", "code": "ST", "path":"https://sitecoretestphd.heart.org//-/media/feature/phd/membershipbriefcaseblack.svg?h=24&amp;w=27&amp;hash=A11AADA7C43F77E34BB5F2814189C976490CCF2C" }
                ]
            }
        }
    }
}
</script>




// WEBPACK FOOTER //
// demo/pages/layouts/tier-selector-api.vue